import { Popup, RadioGroupField } from '@cian/components';
import * as React from 'react';
import { Button } from '../../../../common/components/button';
import { ModalWrapper } from '../../../../common/components/modal/wrapper';
import { IChangePrintOptions } from '../../../state/print';

const style = require('./index.css');

export interface IPrintPopupProps {
  showComments: boolean;
  showPhones: boolean;

  changePrintOptions(options: IChangePrintOptions): void;
  close(): void;
}

export const printPhonesValues = [
  {
    value: 1,
    label: 'С телефонами',
  },
  {
    value: 0,
    label: 'Без телефонов',
  },
];

export const printCommentValues = [
  {
    value: 1,
    label: 'С комментарием',
  },
  {
    value: 0,
    label: 'Без комментария',
  },
];

export class PrintPopup extends React.PureComponent<IPrintPopupProps> {
  public render() {
    const { close, showComments, showPhones } = this.props;

    return (
      <ModalWrapper containerStyle={style['container']} onClose={close}>
        <Popup containerStyle={style['popup']}>
          <button className={style['popup-close']} onClick={close}></button>
          <h3 className={style['popup-title']}>Распечатать все объявления на странице</h3>
          <form onSubmit={this.handleSubmit}>
            <div className={style['popup-triggers']}>
              <RadioGroupField
                containerStyle={style['popup-triggersGroup']}
                value={Number(showPhones)}
                onValueChange={this.handlePrintPhonesChange}
                values={printPhonesValues}
              />
              <RadioGroupField
                containerStyle={style['popup-triggersGroup']}
                value={Number(showComments)}
                onValueChange={this.handlePrintCommentChange}
                values={printCommentValues}
              />
            </div>
            <div className={style['popup-actions']}>
              <Button theme="primary">Распечатать</Button>
              <Button theme="primary" mode="outline" onClick={close}>
                Отменить
              </Button>
            </div>
          </form>
        </Popup>
      </ModalWrapper>
    );
  }

  private handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.props.changePrintOptions({
      enabled: true,
    });
    setTimeout(() => {
      window.print();
      this.props.changePrintOptions({
        enabled: false,
      });
      this.props.close();
    });
  };

  private handlePrintPhonesChange = (showPhones: number) => {
    this.props.changePrintOptions({
      showPhones: showPhones === 1,
    });
  };

  private handlePrintCommentChange = (showComments: number) => {
    this.props.changePrintOptions({
      showComments: showComments === 1,
    });
  };
}
